<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    size="tiny"
    :close-on-click-modal="false"
    @close="onClose"
  >
    <div class="m-token-content">
      <div class="binding" v-if="!isBinder">
        <p>请使用“M令牌”App扫描二维码，然后输入6位动态验证码完成绑定。</p>
        <div class="qr-code" ref="secretRef"></div>
        <p class="secret">无法扫码时可手动输入密钥：{{ secret }}</p>
      </div>
      <el-input
        v-model="token"
        :maxlength="6"
        autofocus
        placeholder="请输入M令牌生成的6位动态验证码"
        @keyup.enter.native="submit"
      ></el-input>
      <p class="error" v-if="error">{{ error }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">返回</el-button>
      <el-button type="primary" :loading="submitting" @click="submit">校验</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      submitting: false,
      title: '请进行M令牌验证',
      mode: 'login',
      challenge: '',
      account: '',
      token: '',
      secret: '',
      isBinder: true,
      error: ''
    }
  },
  methods: {
    show(options) {
      const data = options || {}
      this.mode = data.mode || 'login'
      this.challenge = data.challenge || ''
      this.account = data.account || ''
      this.token = ''
      this.secret = ''
      this.error = ''

      if (this.mode === 'disable') {
        this.isBinder = true
        this.title = '关闭M令牌验证'
        this.visible = true
        return
      }

      const url = this.mode === 'login' ? '/api/login_m_token_auth' : '/api/m_token_auth'
      const params = this.mode === 'login' ? { challenge: this.challenge } : {}

      this.$ajax.post(url, params).then(res => {
        const response = res.data || {}
        const result = response.data || response
        if (response.error) {
          this.showError(response.error)
          this.$message.error(this.error)
          return
        }

        this.isBinder = !!result.is_binder
        this.secret = result.secret || ''
        this.title = this.isBinder ? '请进行M令牌验证' : '请进行M令牌绑定'
        this.visible = true

        if (!this.isBinder) {
          this.$nextTick(this.renderQrCode)
        }
      }).catch(() => {
        this.$message.error('M令牌服务异常，请稍后重试！')
      })
    },
    renderQrCode() {
      this.loadQrCode(() => {
        if (!window.create || !this.$refs.secretRef) {
          this.error = '二维码组件加载失败，请刷新页面重试'
          return
        }

        this.$refs.secretRef.innerHTML = ''
        window.create.createcode({
          ele: this.$refs.secretRef,
          data: { state: 0, secret: this.secret },
          arg: 'MM运营后台::' + this.account,
          width: 220,
          height: 220
        })
      })
    },
    loadQrCode(callback) {
      if (window.create) {
        callback()
        return
      }

      require.ensure([], require => {
        require('../../statics/js/mtoken.js')
        callback()
      }, () => {
        this.error = '二维码组件加载失败，请刷新页面重试'
      }, 'm-token-qr')
    },
    submit() {
      const token = String(this.token || '').trim()
      if (!/^\d{6}$/.test(token)) {
        this.error = '请输入6位动态验证码'
        return
      }

      let url = '/api/check_m_token'
      const params = { token: token }

      if (this.mode === 'login') {
        url = '/api/login_m_token_check'
        params.challenge = this.challenge
      } else if (this.mode === 'disable') {
        url = '/api/disable_m_token'
      }

      this.submitting = true
      this.error = ''
      this.$ajax.post(url, params).then(res => {
        const response = res.data || {}
        if (response.error) {
          this.showError(response.error)
          return
        }

        this.visible = false
        this.$emit('verified', { mode: this.mode, response: response })
      }).catch(() => {
        this.error = '网络连接失败，请稍后重试'
      }).then(() => {
        this.submitting = false
      })
    },
    showError(error) {
      if (error === 'token error' || String(error) === '422') {
        this.error = '验证码错误，请重新输入'
      } else if (error === 'login challenge expired') {
        this.error = '登录验证已过期，请返回后重新登录'
      } else {
        this.error = 'M令牌服务异常，请稍后重试'
      }
    },
    onClose() {
      this.token = ''
      this.error = ''
      this.$emit('closed', this.mode)
    }
  }
}
</script>

<style lang="scss" scoped>
.m-token-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px 20px 0;

  .binding {
    width: 100%;
    color: #666;
    line-height: 1.6;
    text-align: center;
  }

  .qr-code {
    display: flex;
    justify-content: center;
    min-height: 220px;
    margin: 12px 0;
  }

  .secret {
    color: #999;
    font-size: 12px;
    word-break: break-all;
  }

  .error {
    width: 100%;
    margin: 10px 0 0;
    color: #f56c6c;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// mTokenDialog.vue?707fc918